import {
  RAW_MATERIAL_CATEGORIES,
  RAW_MATERIAL_KINDS,
} from "@artisancode/api-types";
import { z } from "zod";

export const rawMaterialSchema = z
  .object({
    name: z.string().min(1, "Nama bahan baku wajib diisi"),
    sku: z.string().optional(),
    category: z.enum(RAW_MATERIAL_CATEGORIES),
    kind: z.enum(RAW_MATERIAL_KINDS),
    uomId: z.string().min(1, "Satuan wajib dipilih"),
    ingredientId: z.string().optional(),
    minStock: z.number().min(0).optional(),
    notes: z.string().optional(),
    workspaceId: z.string().optional(),
  })
  .superRefine((v, ctx) => {
    if (v.kind !== "purchased") return;
    if (!v.ingredientId) {
      ctx.addIssue({
        code: "custom",
        path: ["ingredientId"],
        message: "Bahan resep wajib dipilih",
      });
    }
  });

export type RawMaterialFormValues = z.infer<typeof rawMaterialSchema>;

export const defaultRawMaterialValues: RawMaterialFormValues = {
  name: "",
  sku: "",
  category: "coffee_beans",
  kind: "ingredient",
  uomId: "",
  ingredientId: "",
  minStock: undefined,
  notes: "",
  workspaceId: "",
};
